import { useSmartProp } from '@smartfire/js-block-engine';
import {
    PanelBody,
    PanelRow,
    SelectControl,
    ToggleControl,
    Button as WPButton,
    ButtonGroup as WPButtonGroup,
} from '@wordpress/components';
import { LinkControl } from '../shared/components/link-control';

export const Inspector = () => {
    const [type, setType] = useSmartProp('type');
    const [externalBorder, setExternalBorder] = useSmartProp('externalBorder');
    const [align, setAlign] = useSmartProp('align');

    return (
        <>
            <LinkControl />
            <PanelBody title="Style" initialOpen={true}>
                <PanelRow>
                    <SelectControl
                        label="Type"
                        value={type}
                        onChange={setType}
                        options={[
                            { value: 'filled', label: 'Plein' },
                            { value: 'outlined', label: 'Bordure' },
                            { value: 'noborder', label: 'Sans-bordure' },
                        ]}
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label={'Avec bordures externes'}
                        checked={externalBorder}
                        onChange={(value) => setExternalBorder(value)}
                    />
                </PanelRow>
                <PanelRow>Alignement</PanelRow>
                <PanelRow>
                    <WPButtonGroup label="Alignement">
                        <WPButton variant={align === 'left' && 'primary'} onClick={() => setAlign('left')}>
                            Gauche
                        </WPButton>
                        <WPButton variant={align === 'center' && 'primary'} onClick={() => setAlign('center')}>
                            Centré
                        </WPButton>
                        <WPButton variant={align === 'fullwidth' && 'primary'} onClick={() => setAlign('fullwidth')}>
                            Pleine largeur
                        </WPButton>
                        <WPButton variant={align === 'right' && 'primary'} onClick={() => setAlign('right')}>
                            Droite
                        </WPButton>
                    </WPButtonGroup>
                </PanelRow>
            </PanelBody>
        </>
    );
};

export default Inspector;
